import { Place } from '@types';

export const MAX_OVERLAP_DISTANCE_KM = 10;

export function placesOverlap(placeA: Place, placeB: Place) {
  if (placeA.placeId === placeB.placeId) {
    return true;
  }
  try {
    if (computeDistanceInKm(placeA, placeB) <= MAX_OVERLAP_DISTANCE_KM) {
      return true;
    }
  } catch (error) {
    // TODO: log this error to sentry
    console.error(error);
  }
  return false;
}

export type Coordinates = {
  latitude: number;
  longitude: number;
};

export function computeDistanceInKm(placeA: Coordinates, placeB: Coordinates) {
  const radius = 6371; // Radius of the earth in km
  const dLat = deg2rad(placeB.latitude - placeA.latitude);
  const dLng = deg2rad(placeB.longitude - placeA.longitude);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(placeA.latitude)) *
      Math.cos(deg2rad(placeB.latitude)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = radius * c; // Distance in km
  return d;
}

function deg2rad(deg: number) {
  return deg * (Math.PI / 180);
}

export function getCoordinateBounds(center: Coordinates, distanceKm: number) {
  const latitudeDelta = (distanceKm / 111) * 2;
  const longitudeKmPerDegree = Math.max(111 * Math.cos(deg2rad(center.latitude)), 0.0001);
  const longitudeDelta = (distanceKm / longitudeKmPerDegree) * 2;

  return {
    latitude: center.latitude,
    longitude: center.longitude,
    latitudeDelta,
    longitudeDelta,
  };
}
